<div class="flex justify-center mobile:px-5 laptop:px-8 overflow-y-auto" *ngIf="branding">
  <div class="pt-5 w-343 tablet:w-768 laptop:w-912 tablet:px-6">
    <interview-dashboard
      [dashboardInfo]="dashboardInfo$ | async"
      [upcomingMeetings]="upcomingMeetings"
      [pastMeetings]="pastMeetings"
      (onViewInterviewDetails)="showViewDetailsPage($event)"
    ></interview-dashboard>
  </div>
</div>
